// Which batches of a matrix-family question are open. The drawn list and the exporters both ask
// here, so a report exports exactly the batches the reader sees open.

// Which batches are open, read from the value the collapse param persists ("1.3.4" or an array).
export const parseUncollapsed = uncollapsed => {
  if (Array.isArray(uncollapsed)) return uncollapsed.map(String)

  if ('string' === typeof uncollapsed && 0 < uncollapsed.length) {
    return uncollapsed.split('.').filter(value => 0 < value.length)
  }

  return []
}

// A question with a single batch has nothing to choose between, so that batch opens on its own --
// and a hidden batch is never closed, since there is no row left to reopen it from.
export const calcOpenKeys = ({ batches, uncollapsed }) => {
  const stored = parseUncollapsed(uncollapsed)
  if (stored.length) return stored

  if (1 === batches.length) return [String(batches[0].position)]

  return batches.filter(batch => batch.hidden).map(batch => String(batch.position))
}
